import { createContext } from 'react';
const measureContext = createContext<any>({});
export default measureContext;